import { BooleanField, ModelField, ModelGroup, ModelItem, NumberField, StringField } from '@mng/model';

export function createVermittlerInformationGroup(): ModelGroup {
  const vermittlerGroup: ModelGroup = new ModelGroup('vermittlerInfo', 'Vermittler')
    .withInterfaceName('VermittlerDto')
    .withImportDef({
      importStatement: `import { VermittlerDto } from '@mng/domain'`
    })
    .addItems(...createVermittlerInformationen());
  return vermittlerGroup;
}

export function createVermittlerInfoBlattAbberGroup(): ModelGroup {
  const vermittlerGroup: ModelGroup = new ModelGroup('vermittlerInfoBlattAbber', 'VIB-Abber')
    .withInterfaceName('VermittlerDto')
    .withImportDef({
      importStatement: `import { VermittlerDto } from '@mng/domain'`
    })
    .addItems(...createVermittlerInformationen());
  return vermittlerGroup;
}

export function createVermittlerInformationen(): ModelItem[] {
  const vermittlerName: ModelGroup = new ModelGroup('vermittlerName', 'Vermittlername').withInterfaceName(
    'VermittlerNameDto'
  );
  const vermittlerNrField: ModelField = new NumberField('vermittlerNr', 'Vermittlernummer');
  const makler: ModelField = new BooleanField('makler', 'Makler').withReadOnly();
  const kooperationspartner: ModelField = new BooleanField('kooperationspartner', 'Kooperationspartner').withReadOnly();
  const courtage: ModelField = new StringField('courtage', 'Courtage').withReadOnly();
  const hasGv: ModelField = new BooleanField('hasGv', 'GV-Lizenz').withReadOnly();
  const hasLv: ModelField = new BooleanField('hasLv', 'LV-Lizenz').withReadOnly();
  const hasSv: ModelField = new BooleanField('hasSv', 'SV-Lizenz').withReadOnly();
  const hasUv: ModelField = new BooleanField('hasUv', 'UV-Lizenz').withReadOnly();
  const vseRequired: ModelField = new BooleanField('vseRequired', 'vse').withReadOnly();
  const abkommen: ModelField = new NumberField('abkommen', 'Abkommensnummer').withReadOnly();
  const abberType: ModelField = new StringField('abberType', 'Abber-Typ').withReadOnly();
  const isMaklerspitze: ModelField = new BooleanField('isMaklerspitze', 'Ist Maklerspitze').withReadOnly();
  const isTeamPartnerSpitze: ModelField = new BooleanField(
    'isTeamPartnerSpitze',
    'Ist Team-Partner-Spitze'
  ).withReadOnly();
  const hasDisplayableSubordinates: ModelField = new BooleanField(
    'hasDisplayableSubordinates',
    'Hat untergeordnete Vermittler'
  ).withReadOnly();
  const name1: ModelField = new StringField('nachname', 'Name/Firma');
  const name2: ModelField = new StringField('vorname', 'Vorname');
  vermittlerName.addItems(name1, name2);
  return [
    vermittlerNrField,
    vermittlerName,
    makler,
    courtage,
    hasGv,
    hasLv,
    hasSv,
    hasUv,
    vseRequired,
    kooperationspartner,
    abkommen,
    abberType,
    isMaklerspitze,
    isTeamPartnerSpitze,
    hasDisplayableSubordinates
  ];
}
